import React from "react"

/**
 * Ambient universe backdrop — stars and nebula only (no text, no doors).
 */
export default function UniverseScene({ layerRef }) {
  return (
    <div
      ref={layerRef}
      className="universe-layer fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="universe-base" />
      <div className="universe-glow universe-glow--primary" />
      <div className="universe-glow universe-glow--accent" />
      <div className="universe-band" />
      <div className="universe-stars universe-stars--distant" />
      <div className="universe-stars universe-stars--field" />
    </div>
  )
}
